interface FAQItem {
  id: string;
}

export interface Category {
  id: string;
  title: string;
  items: FAQItem[];
}

export const categories: Category[] = [
  {
    id: "user-account",
    title: "User / Account Management",
    items: [
      {
        id: "invite-team-member",
      },
      {
        id: "delete-team-member",
      },
      {
        id: "reset-change-password",
      },
      {
        id: "change-personal-info",
      },
    ],
  },
  {
    id: "resource-management",
    title: "Resource Management",
    items: [
      {
        id: "addresses",
      },
      {
        id: "partners",
      },
      {
        id: "vehicles",
      },
    ],
  },
  {
    id: "shipment-management",
    title: "Shipment Management",
    items: [
      {
        id: "create-shipment",
      },
      {
        id: "view-shipment",
      },
      {
        id: "edit-shipment",
      },
      {
        id: "download-shipment",
      },
      {
        id: "cmr-preview",
      },
      {
        id: "share-cmr",
      },
      {
        id: "validate-efti",
      },
      {
        id: "export-shipment-reports",
      },
      {
        id: "configure-shipment-columns",
      },
      {
        id: "copy-shipment",
      },
      {
        id: "drivers-files-added-to-shipment",
      },
      {
        id: "share-driver-link",
      },
      {
        id: "read-only-shipment-link",
      },
      {
        id: "driver-comments",
      },
    ],
  },
  {
    id: "drivers-app",
    title: "Drivers App",
    items: [
      {
        id: "what-is-drivers-app",
      },
    ],
  },
];
